interface State {
  form: {};
  authLogic: {};
}

export default ({ form, ...rest }: State) => ({
  ...rest,
  authLogic: {
    ...rest.authLogic,
    user: null,
  },
});
